import api from 'api';

export const policyActionHelper = (actionType: string) => {
  switch (Number(actionType)) {
    case 1:
      return api.retainNoChanges;
    case 2:
      return api.retainRebalance;
    case 3:
      return api.retainInternalFundSwitch;
    case 4:
      return api.transferCashFull;
    case 5:
      return api.transferCashPartial;
    case 6:
      return api.transferReRegisterFull;
    case 7:
      return api.transferReRegisterPartial;
    case 8:
      return api.surrenderPartial;
    case 9:
      return api.surrenderFull;
    default:
      return api.transferCashFull;
  }
};
